import { Bar } from "react-chartjs-2";

export default function Analytics({ data }) {
  const labels = data.employees.map(e => e.employee_name);
  const logs = data.employees.map(
    e => data.logs.filter(l => l.employee_id === e.id).length
  );
  const snaps = data.employees.map(
    e => data.snapshots.filter(s => s.employee_id === e.id).length
  );

  return (
    <div className="card">
      <h3>Logs & Snapshots per Employee</h3>
      <Bar
        data={{
          labels,
          datasets: [
            { label: "Logs", data: logs, backgroundColor: "#0ea5e9" },
            { label: "Snapshots", data: snaps, backgroundColor: "#14b8a6" },
          ],
        }}
      />
    </div>
  );
}
